import enLocale from "element-ui/lib/locale/lang/en";
export default {
  message: {
    hello: "hello word",
  },
  enLocale,
};
